import { Components, Theme } from '@mui/material';

const MuiInputBase: Components<Theme>['MuiInputBase'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      gap: theme.spacing(theme.spacingSizes.xs),
    }),
    input: ({ theme }) => ({
      color: theme.palette.grey[900],
      fontWeight: theme.typography.fontWeightMedium,
    }),
    adornedStart: {
      '& .MuiSvgIcon-root': {
        margin: 0,
      },
    },
    adornedEnd: {
      '& .MuiSvgIcon-root': {
        margin: 0,
      },
      '& .MuiButtonBase-root': {
        padding: 0,
        margin: 0,
      }
    },
  },
  variants: [
    {
      props: {
        size: 'small',
      },
      style: ({ theme }) => ({
        padding: theme.spacing(theme.spacingSizes.xs, 3),
        '&.MuiOutlinedInput-root': {
          paddingRight: theme.spacing(3),
        },
        input: {
          fontSize: theme.fontSizes.regular,
          lineHeight: '16px',
          padding: theme.spacing(0),
          minHeight: '24px',
        },
        textarea: {
          fontSize: theme.fontSizes.regular,
        },
      }),
    },
    {
      props: {
        size: 'large',
      },
      style: ({ theme }) => ({
        padding: theme.spacing(theme.spacingSizes.xxs, theme.spacingSizes.sm),
        input: {
          fontSize: theme.fontSizes.xxl,
          lineHeight: '150%',
          padding: theme.spacing(0),
          height: 'auto',
        },
      }),
    },
  ],
};

export default MuiInputBase;
